// Pasos "Bienestar y salud" (4) y "Vida universitaria" (5) del formulario v2.
// Agrupa por sección (valorc) las preguntas del paso que aplican; las condicionadas aparecen o se
// ocultan según las respuestas. Las respuestas viven en InscripcionAgregar (respuestas_caracterizacion).
import React from "react";
import Grid from "@material-ui/core/Grid";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import HomeWorkIcon from "@material-ui/icons/HomeWork";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import { useEstilosInscripcion } from "./estilosInscripcion";
import { Seccion } from "./componentesInscripcion";
import PreguntaCaracterizacion from "./PreguntaCaracterizacion";
import { preguntasDelPaso } from "./caracterizacion";

// Ícono por código de sección; una sección nueva en la genérica usa el de ayuda
const ICONOS = {
  bienestar_acompanamiento: FavoriteBorderIcon,
  salud_accesibilidad: AccessibilityNewIcon,
  intereses_participacion: EmojiPeopleIcon,
  condiciones_permanencia: HomeWorkIcon,
  pregunta_abierta: ChatBubbleOutlineIcon,
};

// El paso 4 abre la Parte 2 del formato de inscripción 2027: lleva su presentación completa
const ENCABEZADOS = {
  4: {
    titulo: "Construyamos juntos tu camino al éxito",
    parrafos: [
      "En nuestra institución creemos que cada estudiante tiene una historia, unas fortalezas y unas necesidades particulares.",
      "El propósito de este formulario es conocerte mejor para identificar oportunamente apoyos académicos, sociales, económicos, de bienestar, inclusión y accesibilidad que contribuyan a tu adaptación, permanencia y éxito durante tu proceso formativo.",
      "La información suministrada será tratada con confidencialidad y utilizada exclusivamente para fines institucionales de acompañamiento y atención integral.",
    ],
    destacado: "Te invitamos a responder con total honestidad. No existen respuestas correctas o incorrectas. Cuanto más te conozcamos, mejor podremos acompañarte.",
    descripcion: "Los campos con * son obligatorios.",
  },
  5: {
    titulo: "Tu vida universitaria",
    descripcion: "Cuéntanos en qué te gustaría participar y qué condiciones podrían influir en tu permanencia. Los campos con * son obligatorios.",
  },
};

export default function PasoCaracterizacion({ props_c, paso }) {
  const classes = useEstilosInscripcion();
  const { preguntas_caracterizacion = [], respuestas_caracterizacion = {}, setRespuestaCaracterizacion, campo_error } = props_c;
  const encabezado = ENCABEZADOS[paso] || { titulo: "", descripcion: "Los campos con * son obligatorios." };

  // Secciones en el orden en que aparecen sus preguntas
  const secciones = [];
  preguntasDelPaso(preguntas_caracterizacion, respuestas_caracterizacion, paso).forEach((p) => {
    let seccion = secciones.find((s) => s.codigo === p.seccion);
    if (!seccion) {
      seccion = { codigo: p.seccion, titulo: p.titulo_seccion || "", preguntas: [] };
      secciones.push(seccion);
    }
    seccion.preguntas.push(p);
  });

  return (
    <React.Fragment>
      <p className={classes.tituloPaso}>{encabezado.titulo}</p>
      {encabezado.parrafos && (
        <div className={classes.introPaso}>
          {encabezado.parrafos.map((texto, i) => <p key={i}>{texto}</p>)}
        </div>
      )}
      {encabezado.destacado && <p className={classes.introDestacado}>{encabezado.destacado}</p>}
      <p className={classes.descripcionPaso}>{encabezado.descripcion}</p>

      {secciones.map((s) => (
        <Seccion key={s.codigo} icono={ICONOS[s.codigo] || HelpOutlineIcon} titulo={s.titulo}>
          {s.preguntas.map((p) => (
            <Grid item xs={12} key={p.codigo} {...(campo_error === p.codigo ? { "data-error": "true" } : {})}>
              <PreguntaCaracterizacion
                pregunta={p}
                respuesta={respuestas_caracterizacion[p.codigo]}
                onCambiar={(cambios) => setRespuestaCaracterizacion(p.codigo, cambios)}
                error={campo_error === p.codigo}
              />
            </Grid>
          ))}
        </Seccion>
      ))}
    </React.Fragment>
  );
}
